<template>
  <div>
    <h2>Listagem Posições de Ativos</h2>

    <v-data-table
      v-if="data.length > 0"
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="perPage"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="searchFilter.query"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="searchFilter.email"
                append-icon="mdi-magnify"
                label="E-mail"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="searchFilter.document"
                append-icon="mdi-magnify"
                label="CPF"
                v-mask="'###.###.###-##'"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total > 0">
            Exibindo {{ from }} - {{ to }} de {{ total }}
          </span>
        </div>
      </template>
    </v-data-table>
    <p v-else>Carregando ou nenhum dado encontrado.</p>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="totalPages"></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Api from '../../services/api.service';

export default {
  name: 'Users',
  data: () => ({
    data: [],
    headers: [
      { text: 'Ativo', value: 'ativo' },
      { text: 'Usuário', value: 'usuario' },
      { text: 'Saldo Atual (Qtde)', value: 'saldo_atual_qtde' },
      { text: 'Valor Atual (R$)', value: 'valor_atual' },
      { text: 'Saldo Atual Financeiro', value: 'saldo_atual_financeiro' },
    ],
    isLoading: true,
    page: 1,
    perPage: 8,
    searchFilter: {
      query: null,
      email: null,
      document: null,
    },
    sortBy: 'id',
    to: 0,
    from: 0,
    total: 0,
    totalPages: 0,
  }),
  watch: {
    page: function () {
      this.loadData();
    },
    searchFilter: {
      handler() {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapMutations(['showSnackbar']),

    loadData() {
      this.isLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        sort: this.sortBy,
        ...(this.searchFilter.query && {
          'filter[nameOrEmail]': this.searchFilter.query,
        }),
        ...(this.searchFilter.email && {
          'filter[email]': this.searchFilter.email,
        }),
        ...(this.searchFilter.document && {
          'filter[document]': this.searchFilter.document.replace(/[^0-9]/g, ''),
        }),
      };

      Api.get('positionActivesList', { params })
        .then(({ data }) => {
          const { from, to, total, data: items, current_page } = data;
          this.data = items;
          this.from = from;
          this.to = to;
          this.total = total;
          this.page = current_page;
          this.totalPages = Math.ceil(total / this.perPage);
        })
        .catch(() => {
          this.showSnackbar({
            text: 'Ops! Ocorreu um erro inesperado',
            color: 'error',
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
